import React from "react"
import { Store } from "./types"
import * as s from "./StoreItem.module.scss"

type StoreItemProps = {
  store: Store
}
export const StoreItem = (props: StoreItemProps) => {
  const { store } = props
  return <div className={s.container}>
    <div className={s.imageContainer}>
      <img className={s.image} src={store.image} alt={store.name} />
    </div>
    <div className={s.informationContainer}>
      <p className={s.name}>{store.name}</p>
      <table className={s.informationTable}>
        <tbody>
          {store.tel && (
            <tr>
              <th>電話番号</th>
              <td>{store.tel}</td>
            </tr>
          )}
          {store.fax && (
            <tr>
              <th>FAX</th>
              <td>{store.fax}</td>
            </tr>
          )}
          {store.email && (
            <tr>
              <th>メール</th>
              <td>{store.email}</td>
            </tr>
          )}
          {store.url && (
            <tr>
              <th>ホームページ</th>
              <td>{store.url}</td>
            </tr>
          )}
          {(store.zip || store.address) && (
            <tr>
              <th>住所</th>
              <td>
                {!!store.zip && `〒${store.zip} `}
                {store.address}
              </td>
            </tr>
          )}
          {store.business_hours && (
            <tr>
              <th>営業時間</th>
              <td>{store.business_hours}</td>
            </tr>
          )}
          {store.regular_holiday && (
            <tr>
              <th>定休日</th>
              <td>{store.regular_holiday}</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
}
